<template>
  <div>
    <baseFrame clearText='' submitText='提交' :submitLoading='submitLoading' @submit='submit'>
      <div slot="affixInfo" class="titleContainer">
        <div>
          <h4>{{ '名称：'+info.ddiRule.name }}</h4>
        </div>
      </div>
      <div slot="content">
        <div class="cardContainer">
          <lk-card title="规则信息">
            <lk-form :label-width='120' label-position='right'>
              <lk-row :gutter='16'>
                <lk-col span='10'>
                  <lk-form-item label='上传方式:'>
                    <lk-radio-group  v-model="info.ddiRule.uploadType" @on-change="getRadioType">
                      <lk-radio :disabled='!able' :label='1'>自动</lk-radio>
                      <lk-radio :disabled='!able' :label='2'>手动</lk-radio>
                    </lk-radio-group>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16' v-if="this.radioType===1">
                <lk-col span='10'>
                  <lk-form-item label='自动上传时间:'>
                    <lk-time-picker  :disabled="!able" v-model="info.ddiRule.cronTab" type='time' style="width:100%"></lk-time-picker>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter="16" v-if="Number(params.ruleType) === 2">
                <lk-col span="23">
                  <lk-form-item label="账户信息:">
                  <lk-button class="mb8" type='primary' v-show="!info.ddiRuleAccountList|| info.ddiRuleAccountList.length===0" @click="accountModal.visiable=true">新建账户信息</lk-button>
                    <lk-table :columns="accountColumns" border :data="info.ddiRuleAccountList"></lk-table>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span='22'>
                <lk-form-item label='药品:'>
                  <div class="mb16">
                  <lk-button v-if="able" type='primary' @click="addGoods">新增</lk-button>
                  <lk-button v-else type='primary' style="visibility: hidden" >新增</lk-button>
                  </div>
                    <lk-table :columns='goodColumns' border :data='info.ddiGoodsVoList'></lk-table>
                </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span='22'>
                <lk-form-item label='门店:'>
                  <div class="mb16">
                    <lk-button v-if="able" type='primary' @click="addStores">新增</lk-button>
                    <lk-button v-else type='primary' style="visibility: hidden" @click="addStores">新s增不用废弃站位</lk-button>
                  </div>
                  <lk-table :columns='storeColumns' border :data='info.ddiStoreVoList' ></lk-table>
                </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-form>
          </lk-card>
        </div>
      </div>
    </baseFrame>
    <lk-modal title="选择商品" v-model="goodsModal" :width='900'>
      <div class="modalContent">
        <div class="modalQuery mb16">
          <div class="queryItem">
            <label>搜索商品:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='goodsQuery.keywords'></lk-input>
          </div>
          <div class="queryItem">
            <lk-button type='primary' @click="getGoodsList(goodsQuery)">搜索</lk-button>
          </div>
        </div>
        <div slot="table" >
          <lk-table border :columns='selectGoodsColumns' @on-selection-change='handleGoodsSelect' :data='goodsList' ></lk-table>
          <div style="text-align:right;padding-top:15px;">
            <lk-page :total="goodsCount" size="small" show-total show-sizer show-elevator @on-change='handlePage' @on-page-size-change='handleSize'></lk-page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <span class="mr8">{{ '已选：'+selectedGoods.length+'项' }}</span>
        <lk-button @click='goodsModal=false'>取消</lk-button>
        <lk-button type='primary' @click="addGoodsConfirm">确定</lk-button>
      </div>
    </lk-modal>
    <lk-modal title="选择门店" v-model="storesModal"  @on-cancel='addStoresCancle'>
      <div>
        <lk-form  :label-width='120' label-position='right' :model='storeForm' ref="storeForm" :rules='storeValide'>
          <lk-row>
            <lk-col span='20'>
              <lk-form-item label='选择门店:' prop='storeId'>
                <lk-select filterable v-model="storeForm.storeId">
                  <lk-option v-for="(item,index) in storeList" :key="index" :value='item.storeId'>{{ item.storeName }}</lk-option>
                </lk-select>
              </lk-form-item>
            </lk-col>
            </lk-row>
            <lk-row>
            <lk-col span='20'>
              <lk-form-item label='门店编码:'  prop='code'>
                <lk-input v-model.trim="storeForm.code" placeholder="请输入对方提供的编码" :maxlength='100'></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
            <lk-row>
            <lk-col span='20' v-if="Number(params.ruleType) === 1">
              <lk-form-item label='用户名:'  prop='userName'>
                <lk-input v-model.trim="storeForm.userName" placeholder="请输入对方提供的用户名" :maxlength='100'></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row>
            <lk-col span='20' v-if="Number(params.ruleType) === 1">
              <lk-form-item label='密码:'  prop='password'>
                <lk-input v-model.trim="storeForm.password" placeholder="请输入对方提供的密码" :maxlength='100'></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row>
            <lk-col span='20'  v-if="Number(params.ruleType) === 1">
              <lk-form-item label='FTP地址:'  prop='ftpUrl'>
                <lk-input v-model.trim="storeForm.ftpUrl" placeholder='请输入对方提供的FTP地址' :maxlength='255'></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </div>
      <div slot="footer">
        <lk-button  @click='addStoresCancle'>取消</lk-button>
        <lk-button type='primary' :loading='storeLoading'  @click="addStoresConfirm">确定</lk-button>
      </div>
    </lk-modal>
    <!-- 编辑门店 开始 -->
    <lk-modal title="编辑门店" v-model="storesModalChange" @on-cancel='changeStoresCancle'>
      <div>
        <lk-form :label-width='120' label-position='right' :model='storeForm' ref="storeFormChange" :rules='storeValide'>
          <lk-row>
              <lk-col span='20'>
                <lk-form-item label='选择门店:' prop='storeId'>
                  <lk-select v-model="storeForm.storeId">
                    <lk-option v-for="(item,index) in storeList" :key="index" :value='item.storeId'>{{ item.storeName }}</lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
          </lk-row>
          <lk-row>
            <lk-col span='20'>
            <lk-form-item label='门店编码:'  prop='code'>
              <lk-input v-model.trim="storeForm.code"></lk-input>
            </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row v-if="Number(params.ruleType) === 1">
            <lk-col span='20'>
              <lk-form-item label='用户名:'  prop='userName'>
                <lk-input v-model.trim="storeForm.userName"></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row v-if="Number(params.ruleType) === 1">
            <lk-col span='20'>
              <lk-form-item label='密码:'  prop='password'>
                <lk-input v-model.trim="storeForm.password"></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row v-if="Number(params.ruleType) === 1">
            <lk-col span='20'>
              <lk-form-item label='FTP地址:'  prop='ftpUrl'>
                <lk-input v-model.trim="storeForm.ftpUrl"></lk-input>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-form>
      </div>
      <div slot="footer">
        <lk-button  @click='changeStoresCancle'>取消</lk-button>
        <lk-button type='primary' :loading='storeLoading'  @click="changeStoresConfirm()">确定</lk-button>
      </div>
    </lk-modal>
    <!-- 编辑门店 结束 -->
    <!-- 编辑账户信息 开始 -->
    <lk-modal
      title="编辑账户信息"
      v-model="accountModal.visiable"
      :mask-closable="false"
      @on-cancel="cancelAccount">
      <lk-form
        ref="accountForm"
        label-position="right"
        :label-width="120"
        :model="accountModel"
        :rules="accountRules">
        <lk-row :gutter="16">
          <lk-col span="20">
            <lk-form-item label="企业名称:" prop="enterprise">
              <lk-input v-model.trim="accountModel.enterprise" :maxlength="100"></lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter="16">
          <lk-col span="20">
            <lk-form-item label="账户编码:" prop="accountCode">
              <lk-input v-model.trim="accountModel.accountCode" :maxlength="100"></lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter="16">
          <lk-col span="20">
            <lk-form-item label="用户名:" prop="userName">
              <lk-input v-model.trim="accountModel.userName" :maxlength="100"></lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter="16">
          <lk-col span="20">
            <lk-form-item label="密码:" prop="password">
              <lk-input v-model.trim="accountModel.password" :maxlength="100"></lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <lk-row :gutter="16">
          <lk-col span="20">
            <lk-form-item label="FTP地址:" prop="ftpUrl">
              <lk-input v-model.trim="accountModel.ftpUrl" :maxlength="255"></lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-form>
      <div slot="footer">
        <lk-button  @click="cancelAccount">取消</lk-button>
        <lk-button type='primary' :loading="accountModal.loading"  @click="editAccountConfirm()">确定</lk-button>
      </div>
    </lk-modal>
    <!-- 编辑账户信息 结束 -->
  </div>
</template>
<script>
import baseFrame from '@/components/frame/BaseFrame.vue';
import dataDirect from '../../services/dataDirect';
import utils from '../../libs/utils';
import permission from '../../mixins/permission';
// import timeStampDatePicker from '@/components/timeStampDatePicker.vue';

export default {
  name: 'ruleInfo',
  mixins: [permission],
  components: {
    baseFrame,
    // timeStampDatePicker,
  },
  data() {
    const validateStoreId = (rule, value, callback) => {
      if (!value) {
        callback(new Error('此处为必填项，不能为空'));
      } else if (this.isRepeat('storeId', value)) {
        callback(new Error('门店账号重复！'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('此处为必填项，不能为空'));
      } else if (this.isRepeat('code', value)) {
        callback(new Error('门店编码重复！'));
      } else {
        callback();
      }
    };
    const validateFtp = (rule, value, callback) => {
      const start = value.substring(0, 6);
      const main = value.slice(6);
      let portStart = main.lastIndexOf(':');
      const pathBegin = main.indexOf('/');
      const atSign = main.indexOf('@');
      let address = '';
      let userInfo = '';
      let path = '';
      let port = '';
      if (atSign === 0) {
        callback(new Error('请填写用户信息'));
      }
      if (atSign >= 0) {
        if (portStart < atSign) {
          portStart = -1;
        }
        let res = main.length;
        pathBegin && (res = pathBegin);
        portStart && (res = portStart);


        address = main.slice(atSign + 1, res);

        console.log(pathBegin);

        userInfo = main.slice(0, atSign);
      } else {
        address = main;
      }
      if (pathBegin >= 0) {
        path = main.slice(pathBegin);
        path && (address = address.replace(path, ''));
      }
      if (portStart >= 0) {
        port = main.slice(portStart + 1, pathBegin >= 0 ? pathBegin : main.length);
        port && (address = address.replace(`:${port}`, ''));
      }
      // console.log(`main:${main}`);
      // console.log(`userInfo:${userInfo}`);
      // console.log(`address:${address}`);
      // console.log(`atSign:${atSign}`);
      // console.log(`port:${port}`);
      // console.log(`path:${path}`);


      if (value === '') {
        callback(new Error('此处为必填项，不能为空'));
      } else if (!start || start != 'ftp://') {
        callback(new Error('请以 ftp:// 开头'));
      } else if (!/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(address)
      && !/^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/.test(address)) {
        callback(new Error('ip/域名填写错误'));// 判定address是否符合条件
      } else if (port && Number.isNaN(port * 1)) {
        callback(new Error('端口错误'));
      } else if (port && (port > 65535 || port < 0)) {
        callback(new Error('端口号超出范围'));
      } else if (path && !/^(\/([a-zA-Z0-9\-?+&amp]*))*$/.test(path)) {
        callback(new Error('文件路径填写错误'));
      } else if (userInfo) {
        console.log(userInfo);

        if (userInfo[0] === ':' || userInfo[userInfo.length - 1] === ':' || userInfo.indexOf(':') != userInfo.lastIndexOf(':')) {
          callback(new Error('用户名密码格式错误'));
        }
      }
      console.log('test');

      callback();
    };
    // const validateFtp = (rule, value, callback) => {
    //   const start = value.substring(0, 6);
    //   const index = value.lastIndexOf(':');
    //   const middle = value.substring(6, index);
    //   const end = value.substring(index);
    //   const portIndex = end.indexOf('/');
    //   const port = end.substring(1, portIndex);
    //   const fileRoot = end.substring(portIndex);
    //   if (value === '') {
    //     callback(new Error('此处为必填项，不能为空'));
    //   } else if (!start || start != 'ftp://') {
    //     callback(new Error('请以 ftp:// 开头'));
    //   } else if (index === 3) {
    //     callback(new Error('请加端口号'));
    //   } else if (!/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(middle)
    //   && !/^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/.test(middle)) {
    //     callback(new Error('ip/域名填写错误'));
    //   } else if ((portIndex == -1 && (end.substring(1) > 65535 || end.substring(1) < 0)) || (portIndex > -1 && (port > 65535 || port < 0))) {
    //     callback(new Error('端口号超出范围'));
    //   } else if ((portIndex === -1 && end.length === 1) || (portIndex > -1 && !port)) {
    //     callback(new Error('请加端口号'));
    //   } else if ((portIndex == -1 && !/^[0-9]*$/.test(end.substring(1))) || (portIndex > -1 && !/^[0-9]*$/.test(port))) {
    //     callback(new Error('端口号填写错误'));
    //   } else if (portIndex > -1 && !/^(\/([a-zA-Z0-9\-?+&amp]*))*$/.test(fileRoot)) {
    //     callback(new Error('文件路径填写错误'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      tempStoreList: [],
      params: {}, // 接收传递过来的参数
      radioType: 1,
      able: false, // 控制显示，查看=false，编辑=true
      submitLoading: false,
      selectedGoods: [],
      storeList: [],
      goodsList: [],
      accountColumns: [
        {
          title: '账户编码',
          key: 'accountCode',
        },
        {
          title: '用户名',
          key: 'userName',
        },
        {
          title: '密码',
          key: 'password',
        },
        {
          title: '企业名称',
          key: 'enterprise',
        },
        {
          title: 'ftp地址',
          key: 'ftpUrl',
        },
        {
          title: '状态',
          key: 'status',
          width: 116,
          render: (h, { row, index }) => (h('lk-switch', {
            props: {
              size: 'large',
              value: row.status === 1,
              disabled: !this.able,
            },
            on: {
              'on-change': (e) => {
                e ? this.info.ddiRuleAccountList[index].status = 1
                  : this.info.ddiRuleAccountList[index].status = 2;
              },
            },
          }, [
            h('span', {
              props: {
              },
              slot: 'open',
            }, '启用'),
            h('span', {
              props: {
              },
              slot: 'close',
            }, '禁用'),
          ])),
        },
        {
          title: '操作',
          width: 116,
          render: (h, { row, index }) => {
            const arr = [];
            arr.push(h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: !this.able,
              },
              on: {
                click: () => {
                  this.accountModal.visiable = true;
                  this.accountModal.index = index;
                  this.accountModel = utils.deepClone(row);
                },
              },
            }, '编辑'));
            return h('div', arr);
          },
        },
      ],
      selectGoodsColumns: [
        {
          type: 'selection',

        },
        {
          title: '商品编码',
          key: 'serialCode',
        },
        {
          title: '商品通用名',
          key: 'approvedName',
        },
        {
          title: '批准文号',
          key: 'approvalCode',
        },
        {
          title: '规格',
          key: 'spec',
        },
        {
          title: '商品名',
          key: 'goodsName',
        },
        {
          title: '生产企业',
          key: 'producer',
        },
        {
          title: '商品状态',
          key: 'goodsBaseStatusStr',
        },
      ],
      goodsQuery: {},
      accountModal: {
        index: 0,
        visiable: false,
        loading: false,
      },
      accountModel: {
        accountCode: '',
        userName: '',
        password: '',
        enterprise: '',
        ftpUrl: '',
      },
      storeForm: {
        storeId: null,
        code: null,
        userName: null,
        password: null,
        ftpUrl: null,
      },
      accountRules: {
        enterprise: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur',
        }],
        accountCode: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur',
        }],
        userName: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur',
        }],
        password: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur',
        }],
        ftpUrl: [{
          required: true, validator: validateFtp, trigger: 'blur', transform: value => (value ? value.trim() : ''),
        }],
      },
      storeValide: {
        storeId: [{
          required: true, validator: validateStoreId, trigger: 'change',
        }],
        code: [{
          required: true, validator: validateCode, trigger: 'blur', transform: value => (value ? value.trim() : ''),
        }],
        userName: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur', transform: value => (value ? value.trim() : ''),
        }],
        password: [{
          required: true, message: '此处为必填项，不能为空。', trigger: 'blur', transform: value => (value ? value.trim() : ''),
        }],
        ftpUrl: [{
          required: true, validator: validateFtp, trigger: 'blur', transform: value => (value ? value.trim() : ''),
        }],
      },
      goodsPage: 1,
      goodsSize: 10,
      goodsCount: 0,
      goodsModal: false,
      goodsLoading: false,
      storesModal: false,
      storeLoading: false,
      storesModalChange: false,
      info: {
        ddiRule: {},
      },
      goodColumns: [
        {
          title: '序号',
          type: 'index',
          width: 60,
        },
        {
          title: '商品编码',
          key: 'serialCode',
        },
        {
          title: '商品通用名',
          key: 'approvedName',
        },
        {
          title: '规格',
          key: 'spec',
        },
        {
          title: '商品名',
          key: 'goodsName',
        },
        {
          title: '生产企业',
          key: 'producer',
        },
        {
          title: '商品状态',
          key: 'goodsBaseStatusStr',
        },
        {
          title: '最后一次添加时间',
          key: 'createTime',
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: !this.able,
              },
              on: {
                click: () => {
                  this.info.ddiGoodsVoList.splice(params.index, 1);
                },
              },
            }, '删除');
          },

        },
      ],
      storeColumns: [
        {
          title: '序号',
          type: 'index',
          width: 60,

        },
        {
          title: '门店名称',
          key: 'storeName',
        },
        {
          title: '门店简称',
          key: 'shortName',
        },
        {
          title: '所属省市区',
          key: 'region',
          width: 110,
        },
        {
          title: '管理员姓名',
          key: 'managerName',
          width: 110,
        },
        {
          title: '编码',
          key: 'code',

        },
        {
          title: '用户名',
          key: 'userName',

        },
        {
          title: '密码',
          key: 'password',
        },
        {
          title: 'FTP地址',
          key: 'ftpUrl',
        },
        {
          title: '状态',
          key: 'status',
          width: 116,
          render: (h, params) => (h('lk-switch', {
            props: {
              size: 'large',
              value: params.row.ddiStoreStatus === 1,
              disabled: !this.able,
            },
            on: {
              'on-change': (e) => {
                e ? this.info.ddiStoreVoList[params.index].ddiStoreStatus = 1
                  : this.info.ddiStoreVoList[params.index].ddiStoreStatus = 2;
              },
            },
          }, [
            h('span', {
              props: {
              },
              slot: 'open',
            }, '启用'),
            h('span', {
              props: {
              },
              slot: 'close',
            }, '禁用'),
          ])),

        },
        {
          title: '操作',
          width: 116,
          render: (h, params) => {
            const arr = [];
            arr.push(h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: !this.able,
              },
              on: {
                click: () => {
                  this.storeForm = utils.deepClone(params.row);
                  this.tempStoreList = utils.deepClone(this.info.ddiStoreVoList);
                  this.tempStoreList.splice(params.index, 1);
                  this.changeStores();
                },
              },
            }, '编辑'));
            // }
            arr.push(h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: !this.able,
              },
              on: {
                click: () => {
                  this.$nextTick(() => {
                    this.info.ddiStoreVoList.splice(params.index, 1);
                  });
                },
              },
            }, '删除'));
            return h('div', arr);
          },

        },
      ],
    };
  },
  computed: {
    selectedIds() {
      const result = [];
      // this.info.financePayableInfoList = [];
      this.info.ddiGoodsVoList.forEach((item) => {
        // this.info.financePayableInfoList.push({
        //   purchaseInspectionInfo: {
        //     id: item.purchaseInspectionInfoId,
        //   },
        // });
        result.push(item.goodsBaseId);
      });
      return result;
    },
  },

  methods: {
    isRepeat(item, value) {
      const temp = this.tempStoreList;
      for (let i = 0; i < temp.length; i++) {
        if (temp[i][item] === value) {
          return true;
        }
      }
      return false;
    },
    getData() {
      dataDirect.getRuleInfo({ id: this.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.info = res.data.data;
          if (this.info.ddiRule.uploadType) {
            this.radioType = this.info.ddiRule.uploadType;
          }
          this.info.ddiGoodsVoList.forEach((item) => {
            item.createTime = utils.formatTime((new Date(item.createTime)).getTime(), 'YYYY/MM/DD HH:mm');
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addGoods() {
      this.goodsModal = true;
      this.selectedGoods = [];
      this.getGoodsList();
    },
    handlePage(val) {
      this.goodsPage = val;
      this.getGoodsList();
    },
    handleSize(val) {
      this.goodsSize = val;
      this.getGoodsList();
    },

    addGoodsConfirm() {
      this.selectedGoods.forEach((item) => {
        item.createTime = utils.formatTime(new Date(), 'YYYY/MM/DD HH:mm');
      });
      this.info.ddiGoodsVoList = this.info.ddiGoodsVoList.concat(this.selectedGoods);
      this.goodsModal = false;
      utils.handleBodyOverFlow(this);
    },
    addStoresCancle() {
      this.$refs.storeForm.resetFields();
      this.storesModal = false;
    },
    addStoresConfirm() {
      this.$refs.storeForm.validate((valid) => {
        if (valid) {
          this.storeList.forEach((item) => {
            if (item.storeId === this.storeForm.storeId) {
              this.storeForm = Object.assign(this.storeForm, item);
              this.storeForm.ddiStoreStatus = 1;
            }
          });
          this.info.ddiStoreVoList.push(utils.deepClone(this.storeForm));
          this.$refs.storeForm.resetFields();
          this.storesModal = false;
        } else {
          this.$Message.error('请填写完整信息');
        }
      });
    },
    changeStoresCancle() {
      this.$refs.storeForm.resetFields();
      this.$refs.storeFormChange.resetFields();
      this.storesModalChange = false;
    },
    changeStoresConfirm() {
      this.$refs.storeFormChange.validate((valid) => {
        if (valid) {
          this.storeList.forEach((item) => {
            if (item.storeId === this.storeForm.storeId) {
              this.storeForm = Object.assign(this.storeForm, item);
            }
          });
          this.info.ddiStoreVoList.splice(this.storeForm._index, 1, utils.deepClone(this.storeForm));
          this.$refs.storeFormChange.resetFields();
          this.storeForm = {
            storeId: null,
            code: null,
            userName: null,
            password: null,
            ftpUrl: null,
          };
          this.storesModalChange = false;
        } else {
          this.$Message.error('请填写完整信息');
        }
      });
    },
    addStores() {
      this.getStoreList();
      this.tempStoreList = this.info.ddiStoreVoList;
      // this.$refs.storeForm.resetFields();
      this.$nextTick(() => {
        this.storesModal = true;
      });
    },
    changeStores() {
      this.getStoreList();
      this.storesModalChange = true;
    },
    getGoodsList(params) {
      if (params) {
        this.goodsPage = 1;
      }
      this.goodsQuery.page = this.goodsPage;
      this.goodsQuery.size = this.goodsSize;
      dataDirect.getGoodsList(this.goodsQuery).then((res) => {
        if (res.data.status === 200) {
          this.goodsList = res.data.data.list;
          this.goodsList.forEach((item) => {
            this.info.ddiGoodsVoList.forEach((elem) => {
              if (elem.goodsBaseId === item.goodsBaseId) {
                item._checked = true;
                item._disabled = true;
              }
            });
          });
          this.goodsCount = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStoreList() {
      dataDirect.getStoreList().then((res) => {
        if (res.data.status === 200) {
          this.storeList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleGoodsSelect(val) {
      this.selectedGoods = [];
      val.forEach((item) => {
        if (!this.selectedIds.includes(item.goodsBaseId)) {
          this.selectedGoods.push(item);
        }
      });
    },
    getRadioType(e) {
      this.radioType = e;
    },
    submit() {
      this.submitLoading = true;
      const params = {};
      params.id = this.info.ddiRule.id;
      params.uploadType = this.info.ddiRule.uploadType;
      params.accountType = this.info.ddiRule.accountType;
      params.cronTab = this.info.ddiRule.cronTab;
      params.uploadUrl = this.info.ddiRule.uploadUrl;
      // 商品和门店列表都不为空
      if (this.info.ddiGoodsVoList && this.info.ddiGoodsVoList.length === 0) {
        this.$Message.error('请至少添加一个商品');
        this.submitLoading = false;
        return;
      }
      if (this.info.ddiStoreVoList && this.info.ddiStoreVoList.length === 0) {
        this.$Message.error('请至少添加一个门店');
        this.submitLoading = false;
        return;
      }

      const ddiRuleAccountList = [];
      this.info.ddiRuleAccountList && this.info.ddiRuleAccountList.forEach((item) => {
        ddiRuleAccountList.push({
          id: item.id,
          userName: item.userName,
          accountCode: item.accountCode,
          password: item.password,
          enterprise: item.enterprise,
          ftpUrl: item.ftpUrl,
          status: item.status,
        });
      });

      params.ddiRuleAccountList = ddiRuleAccountList;
      params.ddiGoods = this.info.ddiGoodsVoList;
      params.ddiStores = this.info.ddiStoreVoList;
      params.ddiGoods = JSON.parse(JSON.stringify(params.ddiGoods).replace(/goodsId/g, 'id'));
      params.ddiGoods.forEach((item) => {
        item.createTime = new Date(item.createTime).getTime();
      });

      dataDirect.updateRule(params).then((res) => {
        if (res.data.status === 200) {
          this.submitLoading = false;
          this.$router.push({ name: 'dataDirectRuleList' });
        } else {
          this.submitLoading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    editAccountConfirm() {
      this.$refs.accountForm.validate((valid) => {
        if (valid) {
          if (this.accountModal.index) {
            this.info.ddiRuleAccountList.splice(this.accountModal.index, 1, utils.deepClone(this.accountModel));
          } else {
            this.info.ddiRuleAccountList = [];
            this.info.ddiRuleAccountList.push(utils.deepClone(this.accountModel));
          }


          this.cancelAccount();
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    cancelAccount() {
      this.$refs.accountForm.resetFields();
      this.accountModal.visiable = false;
    },
  },
  created() {
    if (this.$route.name === 'dataDirectRuleCheck') {
      this.able = false;
    }
    if (this.$route.name === 'dataDirectRuleEdit') {
      this.able = true;
    }

    this.params = this.$route.params;
    this.getData();
  },

};
</script>
<style lang="less" scoped>
.modalContent {
  .modalQuery {
    display: flex;
    .queryItem {
      margin-right: 16px;
      display: flex;
      align-items: center;
      width: 320px;

      label {
        width: 80px
      }
    }
  }
}
.titleContainer{
  background: #fff;
  padding: 0 32px;
  padding-bottom: 12px;
  h4{
    margin-bottom: 4px
  }
}
</style>
